import getCalculatedValues from '../../../lib/guidebook/get-calculated-values';

const pageLocked = (state, config, sectionId, pageId) => {
  const { lockedPages } = getCalculatedValues(state, config);
  return lockedPages.has(`${sectionId} ${pageId}`);
};

export default pageLocked;
